export const CgvQuotes = ({ children }: { children: string }) => {
  return (
    <span className="font-bold">{`«\u00a0${children.trim()}\u00a0»`}</span>
  );
};
